/**
 * Get the provider from the URL query param (?provider=atomic, ?provider=pinwheel, etc).
 * @returns {string} Provider value, or 'pinwheel' when not specified
 */
export const getProvider = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('provider')?.toLowerCase() || 'pinwheel';
};

/**
 * Get the API key based on the current provider (from ?provider=atomic or ?provider=pinwheel).
 */
export const getApiKey = () => {
    const provider = getProvider();
    return provider === 'atomic'
        ? (process.env.REACT_APP_API_KEY_ATOMIC || '6c1278d308a1b9962ce418e5b66e3b6b')
        : (process.env.REACT_APP_API_KEY_PINWHEEL || 'q2-sandbox-key');
};
